import services from '@/http'
import * as types from './mutation-types'

export const ActionGetPreCart = (context,payload) => (
  services.pre_cart.getPreCart(payload).then(res => {
    context.commit(types.PRE_CART_TOTAL, res.body.total_itens_cart)
    context.commit(types.PRE_CART_ITENS, res.body.total_value_cart)
  })

)

export const ActionGetCartComplete = (context,{id}) => (
  services.pre_cart.getCartComplete({id}).then(res => {
    if (res.data.count == 0) {
      context.commit(types.CART, 0)
      return 0
    }
    context.commit(types.CART, res.data.results)
  })
)


export const ActionDeleteCartComplete = ({commit}) => (
    commit(types.DELETE_CART),
    commit(types.DELETE_PRE_CART_TOTAL),
    commit(types.DELETE_CART_ITENS)
)